import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { notifyOpener } from "./oauthPopupBridge";
import linkedInUtils from "../settings/ConnectedAccounts/LinkedInAccounts/common/linkedInUtils";

const LinkedInOAuthCallback = () => {
  useEffect(() => {
    (async () => {
      const accountId = new URLSearchParams(window.location.search).get(
        "account_id"
      );
      if (accountId) {
        await linkedInUtils.markOAuthConnectionStarted(accountId);
      }
      notifyOpener({ type: "LINKEDIN_OAUTH_POPUP_DONE" });
    })();
  }, []);

  return (
    <div className="pageClass">
      <div className="pageCont">
        <div className="connectAppSection">
          <div>Connecting your LinkedIn account…</div>
        </div>
      </div>
    </div>
  );
};

export default observer(LinkedInOAuthCallback);
export { LinkedInOAuthCallback };
